import { Button } from '@bp/ui-components';
import { type FC, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useAuth } from 'react-oidc-context';
import { useParams } from 'react-router-dom';
import { BpSubpage } from '../../components/BpSubpage/BpSubpage';
import { AboutModal } from '../../components/Modals/AboutModal/AboutModal';
import { PageLayoutPlaceholder } from '../../components/PageLayoutPlaceholder/PageLayoutPlaceholder';

export const SignupPage: FC = () => {
  const { t } = useTranslation();
  const auth = useAuth();
  const { invitationToken } = useParams();

  const [showAbout, setShowAbout] = useState<boolean>(false);

  return (
    <BpSubpage>
      <PageLayoutPlaceholder>
        <div className='mb-5'>{t('signup.salutation')}</div>
        <div
          className='mb-2'
          style={{
            fontSize: 'var(--font-size-m)',
            color: 'var(--color-grey-light)',
          }}
        >
          {t('signup.connectInfo')}
        </div>
        <div
          className='mb-3'
          style={{
            fontSize: 'var(--font-size-m)',
            color: 'var(--color-grey-light)',
          }}
        >
          {t('signup.existingInfo')}
        </div>
        <Button
          disabled={true}
          hierarchy={auth.isAuthenticated ? 'primary' : 'secondary'}
          onClick={() =>
            auth.signinRedirect({
              prompt: 'login signup',
              login_hint: invitationToken,
            })
          }
          fullWidth
          className='mt-2'
        >
          {t('signup.connect')}
        </Button>
        <div
          className='mt-5 mb-3'
          style={{
            fontSize: 'var(--font-size-m)',
            color: 'var(--color-grey-light)',
          }}
        >
          {t('signup.createInfo')}
        </div>
        <Button
          hierarchy={!auth.isAuthenticated ? 'primary' : 'secondary'}
          onClick={() =>
            auth.signinRedirect({
              prompt: 'signup login consent',
              login_hint: invitationToken,
            })
          }
          fullWidth
          className='mt-2'
        >
          {t('signup.create')}
        </Button>
        <Button fullWidth hierarchy='tertiary' onClick={() => setShowAbout(true)}>
          {t('common.about')}
        </Button>
      </PageLayoutPlaceholder>
      <AboutModal state={showAbout} setState={(value) => setShowAbout(value)} />
    </BpSubpage>
  );
};
